import React       from 'react';
import ReactDom    from 'react-dom';
// -------------------------------------------------------

class InputSelect extends React.Component {
  update() {
    let value = this.item.value;
    if( value == 'null' ) value = null;
    this.props.update_ev.bind(this)(value);
  }
  
  render() {
    let base = this.props.base;
    let data = this.props.data;
    
    let dm_accounts = [];
    try { dm_accounts = base.projectData.dm_accounts; } catch(e) {}
    
    return (
      <div className="selectbox">
        <select ref={(input) => { this.item = input }} onChange={this.update.bind(this)} defaultValue={data.default}>
          <option value="null">アカウントを選択</option>
          { dm_accounts.map((d, key) => {
            return <option key={key} value={d.id}>{d.insta_id}</option>
           })}
        </select>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InputSelect;